import React, { useCallback } from "react";
import { MoreHorizontal, X, CircleDollarSign, Check } from "lucide-react";
import { useIntl } from "react-intl";
import Popover from "../../../../../../library/UI/Popover";
import ChartTooltip from "../ChartTooltip";
import "./ChartMoreMenu.sass";

const ICON_SIZE = 18;
const CHECK_ICON_SIZE = 10;

const PlLinesButton = ({ chartSettingsApi }) => {
  const intl = useIntl();
  const { settings, updateSettings } = chartSettingsApi;
  const positionLevelsVisible = settings.plLinesVisible;
  const label = intl.formatMessage({ id: "futures.chart.more_menu.pl_lines" });

  const handleTogglePLLines = useCallback(() => {
    updateSettings({ plLinesVisible: !positionLevelsVisible });
  }, [updateSettings, positionLevelsVisible]);

  return (
    <ChartTooltip label={label}>
      <button
        type="button"
        className="chart-toolbar__btn"
        aria-label={label}
        aria-pressed={positionLevelsVisible}
        onClick={handleTogglePLLines}
      >
        <span className="chart-toolbar__btn-icon">
          <CircleDollarSign size={ICON_SIZE} aria-hidden="true" />
        </span>
        {positionLevelsVisible && (
          <span className="chart-toolbar__badge chart-toolbar__badge--check" aria-hidden="true">
            <Check size={CHECK_ICON_SIZE} strokeWidth={3} />
          </span>
        )}
      </button>
    </ChartTooltip>
  );
};

/**
 * «…» toolbar button. Like in PO it does not open a menu panel:
 * the button turns into ✕ and a column of icon buttons appears under it.
 * Each icon button is a toggle with a tooltip and a check badge when on.
 *
 * @param {object} props
 * @param {{ settings: object, updateSettings: Function }} props.chartSettingsApi - useChartSettings
 * @param {boolean} props.isOpen
 * @param {() => void} props.onToggle
 * @param {() => void} props.onClose
 */
const ChartMoreMenu = ({ chartSettingsApi, isOpen, onToggle, onClose }) => {
  const intl = useIntl();
  const label = intl.formatMessage({ id: "futures.chart.toolbar.more" });
  const TriggerIcon = isOpen ? X : MoreHorizontal;

  return (
    <Popover
      isOpen={isOpen}
      onClose={onClose}
      className="chart-more-menu"
      trigger={
        <button
          type="button"
          className={`chart-toolbar__btn${isOpen ? " chart-toolbar__btn--active" : ""}`}
          aria-label={label}
          title={label}
          aria-expanded={isOpen}
          onClick={onToggle}
        >
          <span className="chart-toolbar__btn-icon">
            <TriggerIcon size={ICON_SIZE} aria-hidden="true" />
          </span>
        </button>
      }
    >
      <PlLinesButton chartSettingsApi={chartSettingsApi} />
      {/* TODO TV-04: add more toggles from TV-00 spec §8 when logic is ready */}
    </Popover>
  );
};

export default ChartMoreMenu;
